import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIconSmall } from '@domain-group/fe-co-icon';
import { slugify } from '@domain-group/fe-helper';
import * as styles from './region-group.style';
import * as commonStyles from './common.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var RegionGroup = props => ___EmotionJSX("div", null, ___EmotionJSX("div", {
  css: commonStyles.groupBrowseHeading
}, ___EmotionJSX("p", null, "Choose a Region")), ___EmotionJSX("div", {
  css: styles.regionGroupItems
}, props.regions.map(item => ___EmotionJSX("a", {
  key: slugify(item.name || ''),
  css: styles.regionGroupLink,
  href: item.href,
  onClick: () => {
    if (item.onClick) {
      item.onClick();
    }
  }
}, item.name, ___EmotionJSX(ChevronRightIconSmall, {
  css: styles.regionGroupLinkIcon,
  theme: "allhomes"
})))));
RegionGroup.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }))
};
RegionGroup.defaultProps = {
  regions: []
};
export default RegionGroup;